import React from 'react'

import { withRouter } from 'react-router-dom'

import { AutoComplete } from 'primereact/autocomplete';
import { MultiSelect } from 'primereact/multiselect'
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import { InputNumber } from 'primereact/inputnumber'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import fileDownload from 'js-file-download'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios'

import LocalStorageService from '../../app/service/localStorageService'
import RelatorioProcessoService from '../../app/service/RelatorioProcessoService'
import PessoaService from '../../app/service/PessoaService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import AreaAtuacaoService from '../../app/service/AreaAtuacaoService'
import ObjetoAcaoService from '../../app/service/ObjetoAcaoService'
import TipoPagamentoService from '../../app/service/TipoPagamentoService'
import TiposCustasService from '../../app/service/TiposCustasService'
import PedidoService from '../../app/service/PedidoService'
import UsuarioService from '../../app/service/UsuarioService'
import RitoService from '../../app/service/RitoService'
import MotivoResultadoService from '../../app/service/MotivoResultadoService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import NavBar from '../../componentes/Navbar'

class RelatorioProcessos extends React.Component {
  constructor(props) {
    super(props);

    this.relatorioProcessoService = new RelatorioProcessoService();
    this.pessoaService = new PessoaService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoAcaoService = new TipoAcaoService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.areaAtuacaoService = new AreaAtuacaoService();
    this.objetoAcaoService = new ObjetoAcaoService();
    this.tipoPagamentoService = new TipoPagamentoService();
    this.tiposCustasService = new TiposCustasService();
    this.pedidoService = new PedidoService();
    this.ritoService = new RitoService();
    this.motivoResultadoService = new MotivoResultadoService();
    this.usuarioService = new UsuarioService();

    this.consultarPessoa = this.consultarPessoa.bind(this);
    this.onCamposChange = this.onCamposChange.bind(this);
    this.acoes = this.acoes.bind(this);
    this.accepExcluirRelatorio = this.accepExcluirRelatorio.bind(this);

    this.state = {
      empresa: '',
      detail: '',
      pessoas: [],
      filterPessoas: null,
      selectedPessoa: null,
      gruposTrabalho: [],
      selectedGrupoTrabalho: null,
      statusProcessual: [],
      selectedStatusProcessual: null,
      tiposAcao: [],
      selectedTipoAcao: null,
      tiposDecisao: [],
      selectedTipoDecisao: null,
      areasAtuacao: [],
      selectedAreaAtuacao: null,
      objetosAcao: [],
      selectedObjetoAcao: null,
      pedidos: [],
      selectPedido: null,
      ufs: [],
      selectUf: null,
      ritos: [],
      selectRito: null,
      motivos: [],
      selectMotivo: null,
      usuarios: [],
      responsavel: null,
      bancada: [],
      banca: null,
      //Pesquisas por datas
      dataDistribuicaoInicial: null,
      dataDistribuicaoFinal: null,
      dataSentencaInicial: null,
      dataSentencaFinal: null,
      dataDecisaoInicial: null,
      dataDecisaoFinal: null,
      dataAlteracaoInicial: null,
      dataAlteracaoFinal: null,
      dataCadastroInicial: null,
      dataCadastroFinal: null,
      importanteEmpresa: null,
      importanteParaMim: null,
      estrategico: null,
      excetoArquivados: null,
      dataArquivamentoInicial: null,
      dataArquivamentoFinal: null,
      //as pesquisas que envolvem valor
      tiposPagamento: [],
      selectedTipoPagamento: null,
      operadorLogicoPagamentos: null,
      valorPagamento: '0',
      tiposCusta: [],
      selectedTipoCusta: null,
      operadorLogicoCustas: null,
      valorCustas: '0',
      camposRelatorio: [],
      relatoriosExportados: [],
      codigoExcluirRelatorio: '',
      relatorioArquivo: '',
      openSpinner: false,
    }

    this.estados = [
      {codigo: 'AC', nome: 'Acre'},
      {codigo: 'AL', nome: 'Alagoas'},
      {codigo: 'AM', nome: 'Amazonas'},
      {codigo: 'AP', nome: 'Amapá'},
      {codigo: 'BA', nome: 'Bahia'},
      {codigo: 'CE', nome: 'Ceará'},
      {codigo: 'DF', nome: 'Distrito Federal'},
      {codigo: 'ES', nome: 'Espírito Santo'},
      {codigo: 'GO', nome: 'Goiás'},
      {codigo: 'MA', nome: 'Maranhão'},
      {codigo: 'MG', nome: 'Minas Gerais'},
      {codigo: 'MS', nome: 'Mato Grosso do Sul'},
      {codigo: 'MT', nome: 'Mato Grosso'},
      {codigo: 'PA', nome: 'Pará'},
      {codigo: 'PB', nome: 'Paraíba'},
      {codigo: 'PE', nome: 'Pernambuco'},
      {codigo: 'PI', nome: 'Piauí'},
      {codigo: 'PR', nome: 'Paraná'},
      {codigo: 'RJ', nome: 'Rio de janeiro'},
      {codigo: 'RN', nome: 'Rio Grande do Norte'},
      {codigo: 'RO', nome: 'Rondônia'},
      {codigo: 'RR', nome: 'Roraima'},
      {codigo: 'RS', nome: 'Rio Grande do Sul'},
      {codigo: 'SC', nome: 'Santa Catarina'},
      {codigo: 'SE', nome: 'Sergipe'},
      {codigo: 'SP', nome: 'São Paulo'},
      {codigo: 'TO', nome: 'Tocantins'}
    ];

    this.operadorLogicoOptions = [
      {codigo: 'IGUAL', nome: 'Igual'},
      {codigo: 'MAIOR', nome: 'Maior que'},
      {codigo: 'MAIORIGUAL', nome: 'Maior ou igual'},
      {codigo: 'MENOR', nome: 'Manor'},
      {codigo: 'MENORIGUAL', nome: 'Manor ou igual'}
    ];

    this.importanteEmpresa = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.importanteParaMim = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ];

    this.estrategico = [
      {codigo: 'S', nome: 'Sim'},
      {codigo: 'N', nome: 'Não'}
    ]
  }

  listarBancadas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.pessoaService.listarBancadas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({bancada: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao listar Usuarios', life: 4000});
      });
  }

  listarUsuarios = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({usuarios: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao listar Usuarios', life: 4000});
      })
  }

  consultarRitos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.ritoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({ritos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao consultar ritos de processo', life: 4000});
      })
  }

  consultarMotivosResultado = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.motivoResultadoService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({motivos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:'Erro ao consultar motivos de resultado', life: 4000});
      })
  }

  consultaRelatoriosUsuario = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.relatorioProcessoService.listarRelatoriosExportados(usuarioLogado.codigo)
      .then(response => {
        this.setState({relatoriosExportados: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarPessoas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pessoaService.listarPessoas(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatórios de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarPessoa(event) {
    setTimeout(() => {
        let filterPessoas;
        if (!event.query.trim().length) {
            filterPessoas = [...this.state.pessoas];
        }
        else {
            filterPessoas = this.state.pessoas.filter((pessoa) => {
                return pessoa.nome.toLowerCase().startsWith(event.query.toLowerCase());
            });
        }

        this.setState({ filterPessoas });
    }, 250);
  }

  listarGruposTrabalho = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarStatusProcessual = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.statusProcessualService.listarStatusProcessual(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusProcessual: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposAcao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoAcaoService.listarTipoAcao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposDecisao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoDecisaoService.listarTiposDecisao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposDecisao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listaAreaAtuacao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.areaAtuacaoService.listarAreaAtuacao(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({areasAtuacao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarObjetosAcao = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.objetoAcaoService.consultaRelatorio(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposPagamentos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tipoPagamentoService.listarTiposPagamentos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposPagamento: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposCustas = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tiposCustasService.listarTiposCusta(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposCusta: response.data})
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarTiposPedidos = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.pedidoService.listarPedidos(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({pedidos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarPessoas();
    await this.listarGruposTrabalho();
    await this.listarStatusProcessual();
    await this.listarTiposAcao();
    await this.listarTiposDecisao();
    await this.listaAreaAtuacao();
    await this.listarObjetosAcao();
    await this.listarTiposPagamentos();
    await this.listarTiposCustas();
    await this.consultaRelatoriosUsuario();
    await this.listarTiposPedidos();
    await this.consultarRitos();
    await this.consultarMotivosResultado();
    await this.listarUsuarios();
    await this.listarBancadas();
    this.limparCamposPesquisa();
    this.setState({openSpinner: false});
  }

  onCamposChange(e) {
    let selectCampos = [...this.state.camposRelatorio];

    if (e.checked)
      selectCampos.push(e.value);
    else
      selectCampos.splice(selectCampos.indexOf(e.value), 1);

    this.setState({ camposRelatorio: selectCampos });
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  emitirRelatorio = () => {
    if(this.state.selectedPessoa == null && 
       this.state.selectedGrupoTrabalho == null &&
       this.state.selectedStatusProcessual == null &&
       this.state.selectedTipoDecisao == null &&
       this.state.selectedTipoAcao == null &&
       this.state.selectedAreaAtuacao == null &&
       this.state.selectedObjetoAcao == null &&
       this.state.dataDistribuicaoInicial == null &&
       this.state.dataDistribuicaoFinal == null &&
       this.state.dataSentencaInicial == null &&
       this.state.dataSentencaFinal == null &&
       this.state.dataDecisaoInicial == null &&
       this.state.dataDecisaoFinal == null &&
       this.state.dataCadastroInicial == null &&
       this.state.dataCadastroFinal == null &&
       this.state.dataAlteracaoInicial == null &&
       this.state.dataAlteracaoFinal == null &&
       this.state.operadorLogicoPagamentos == null &&
       this.state.operadorLogicoCustas == null &&
       this.state.selectedTipoPagamento == null &&
       this.state.selectedTipoCusta == null &&
       this.state.valorPagamento == '0' &&
       this.state.valorCustas == '0' &&
       this.state.selectPedido == null &&
       this.state.selectRito == null &&
       this.state.selectMotivo == null &&
       this.state.selectUf == null &&
       this.state.dataArquivamentoInicial == null &&
       this.state.dataArquivamentoFinal == null &&
       this.state.importanteEmpresa == null &&
       this.state.importanteParaMim == null &&
       this.state.estrategico == null &&
       this.state.responsavel == null &&
       this.state.banca == null) {
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Nenhum filtro selecionado', life: 4000});
        return;
    
    } else {

        const usuarioLogado = this.context.usuarioAutenticado;
        
        var areaAtuacao = 0;
        var tipoDecisao = 0;
        var tipoAcao = 0;
        var rito = 0;
        var motivoResultado = 0;
        var uf = '0';
        var importanteEmpresa = '0';
        var importanteParaMim = '0';
        var estrategico = '0';
        var responsavel = '0';
        var banca = '0';
    
        if(this.state.selectedAreaAtuacao != null) {
          areaAtuacao = this.state.selectedAreaAtuacao.codigo;
        }

        if(this.state.selectedTipoDecisao != null) {
          tipoDecisao = this.state.selectedTipoDecisao.codigo;
        }

        if(this.state.selectedTipoAcao != null) {
          tipoAcao = this.state.selectedTipoAcao.codigo;
        }

        if(this.state.selectRito != null) {
          rito = this.state.selectRito.codigo;
        }

        if(this.state.selectMotivo != null) {
          motivoResultado = this.state.selectMotivo.codigo;
        }

        if(this.state.selectUf != null) {
          uf = this.state.selectUf.codigo;
        }

        if(this.state.importanteEmpresa != null) {
          importanteEmpresa = this.state.importanteEmpresa.codigo;
        }

        if(this.state.importanteParaMim != null) {
          importanteParaMim = this.state.importanteParaMim.codigo;
        }

        if(this.state.estrategico != null) {
          estrategico = this.state.estrategico.codigo;
        }

        if(this.state.responsavel != null) {
          responsavel = this.state.responsavel.codigo;
        }

        if(this.state.banca != null) {
          banca = this.state.banca.codigo;
        }

        var contador = 0;
        var tamanhoLista = 0;

        //Pessoas
        var codigosPessoa = '0';
        if(this.state.selectedPessoa != null) {
          contador = 0;
          tamanhoLista = this.state.selectedPessoa.length;
          for(let i = 0; i < this.state.selectedPessoa.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosPessoa = codigosPessoa + this.state.selectedPessoa[i].codigo + ",";
            } else {
              codigosPessoa = codigosPessoa + this.state.selectedPessoa[i].codigo;
            }
            contador++;
          }
        }

        //Objetos de Ação
        var codigosObjetos = '0';
        if(this.state.selectedObjetoAcao != null) {
          contador = 0;
          tamanhoLista = this.state.selectedObjetoAcao.length;
          for(let i = 0; i < this.state.selectedObjetoAcao.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosObjetos = codigosObjetos + this.state.selectedObjetoAcao[i].codigo + ",";
            } else {
              codigosObjetos = codigosObjetos + this.state.selectedObjetoAcao[i].codigo;
            }

            contador++;
          }
        }

        //Grupos de Trabalho
        var codigosGrupos = '0';
        if(this.state.selectedGrupoTrabalho != null) {
          contador = 0;
          tamanhoLista = this.state.selectedGrupoTrabalho.length;
          for(let i = 0; i < this.state.selectedGrupoTrabalho.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosGrupos = codigosGrupos + this.state.selectedGrupoTrabalho[i].codigo + ",";
            } else {
              codigosGrupos = codigosGrupos + this.state.selectedGrupoTrabalho[i].codigo;
            }

            contador++;
          }
        }

        //Status Processual
        var codigosStatusProcessuais = '0';
        if(this.state.selectedStatusProcessual != null) {
          contador = 0;
          tamanhoLista = this.state.selectedStatusProcessual.length;
          for(let i = 0; i < this.state.selectedStatusProcessual.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosStatusProcessuais = codigosStatusProcessuais + this.state.selectedStatusProcessual[i].codigo + ",";
            } else {
              codigosStatusProcessuais = codigosStatusProcessuais + this.state.selectedStatusProcessual[i].codigo;
            }

            contador++;
          }
        }

        //Pagamentos
        var codigosPagamentos = '0';
        if(this.state.selectedTipoPagamento != null) {
          contador = 0;
          tamanhoLista = this.state.selectedTipoPagamento.length;
          for(let i = 0; i < this.state.selectedTipoPagamento.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosPagamentos = codigosPagamentos + this.state.selectedTipoPagamento[i].codigo + ",";
            } else {
              codigosPagamentos = codigosPagamentos + this.state.selectedTipoPagamento[i].codigo;
            }

            contador++;
          }
        }

        //Valores do pagamento
        var operadorLogicoPagamentos = '0'
        if(this.state.valorPagamento != '0') {
          if(this.state.operadorLogicoPagamentos == null) {
            this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Informe o operador lógico dos pagamentos', life: 4000});
            return false;
          }

          operadorLogicoPagamentos = this.state.operadorLogicoPagamentos.codigo;
        }

        //Custas
        var codigosCustas = '0';
        if(this.state.selectedTipoCusta != null) {
          contador = 0;
          tamanhoLista = this.state.selectedTipoCusta.length;
          for(let i = 0; i < this.state.selectedTipoCusta.length; i++) {
            if(contador < tamanhoLista -1) {
              codigosCustas = codigosCustas + this.state.selectedTipoCusta[i].codigo + ",";
            } else {
              codigosCustas = codigosCustas + this.state.selectedTipoCusta[i].codigo;
            }
            
            contador++;
          }
        }

        //Valores das custas
        var operadorLogicoCustas = '0';
        if(this.state.valorCustas != '0') {
          if(this.state.operadorLogicoCustas == null) {
            this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Informe o operador lógico das custas', life: 4000});
            return false;
          }
          operadorLogicoCustas = this.state.operadorLogicoCustas.codigo;
        }

        //Pedidos
        var codigosPedidos = '0';
        if(this.state.selectPedido != null) {
          let contador = 0;
          for(let i = 0; i < this.state.selectPedido.length; i++) {
            if(contador < this.state.selectPedido.length -1) {
              codigosPedidos = codigosPedidos + this.state.selectPedido[i].codigo + ',';
            } else {
              codigosPedidos = codigosPedidos + this.state.selectPedido[i].codigo;
            }
            contador++;
          }
        }

        //Data de decisão
        var dataDecisaoInicial = '0';
        var dataDecisaoFinal = '0';
        if(this.state.dataDecisaoInicial != null && this.state.dataDecisaoFinal != null) {
          //Data inicial
          var dateInicial = this.state.dataDecisaoInicial;
          var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
          var day = this.pad2(dateInicial.getDate());//day (1-31)
          var year= dateInicial.getFullYear();
          dataDecisaoInicial =  year+"-"+month+"-"+day;
          //Data final
          var dateFinal = this.state.dataDecisaoFinal;
          var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
          var day = this.pad2(dateFinal.getDate());//day (1-31)
          var year= dateFinal.getFullYear();
          dataDecisaoFinal =  year+"-"+month+"-"+day;
        }

        //Data da sentença
        var dataSentencaInicial = '0';
        var dataSentencaFinal = '0';
        if(this.state.dataSentencaInicial != null && this.state.dataSentencaFinal != null) {
          //Data inicial
          var dateInicial = this.state.dataSentencaInicial;
          var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
          var day = this.pad2(dateInicial.getDate());//day (1-31)
          var year= dateInicial.getFullYear();
          dataSentencaInicial =  year+"-"+month+"-"+day;
          //Data final
          var dateFinal = this.state.dataSentencaFinal;
          var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
          var day = this.pad2(dateFinal.getDate());//day (1-31)
          var year= dateFinal.getFullYear();
          dataSentencaFinal =  year+"-"+month+"-"+day;
        }

        //Data da distribuição
        var dataDistribuicaoInicial = '0';
        var dataDistribuicaoFinal = '0';
        if(this.state.dataDistribuicaoInicial != null && this.state.dataDistribuicaoFinal != null) {
          //Data inicial
          var dateInicial = this.state.dataDistribuicaoInicial;
          var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
          var day = this.pad2(dateInicial.getDate());//day (1-31)
          var year= dateInicial.getFullYear();
          dataDistribuicaoInicial =  year+"-"+month+"-"+day;
          //Data final
          var dateFinal = this.state.dataDistribuicaoFinal;
          var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
          var day = this.pad2(dateFinal.getDate());//day (1-31)
          var year= dateFinal.getFullYear();
          dataDistribuicaoFinal =  year+"-"+month+"-"+day;
        }

        //Data de Cadastro
        var dataCadastroInicial = '0';
        var dataCadastroFinal = '0';
        if(this.state.dataCadastroInicial != null && this.state.dataCadastroFinal != null) {
          //Data inicial
          var dateInicial = this.state.dataCadastroInicial;
          var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
          var day = this.pad2(dateInicial.getDate());//day (1-31)
          var year= dateInicial.getFullYear();
          dataCadastroInicial =  year+"-"+month+"-"+day;
          //Data final
          var dateFinal = this.state.dataCadastroFinal;
          var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
          var day = this.pad2(dateFinal.getDate());//day (1-31)
          var year= dateFinal.getFullYear();
          dataCadastroFinal =  year+"-"+month+"-"+day;
        }

        //Data de Alteração
        var dataAlteracaoInicial = '0';
        var dataAlteracaoFinal = '0';
        if(this.state.dataAlteracaoInicial != null && this.state.dataAlteracaoFinal != null) {
          //Data inicial
          var dateInicial = this.state.dataAlteracaoInicial;
          var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
          var day = this.pad2(dateInicial.getDate());//day (1-31)
          var year= dateInicial.getFullYear();
          dataAlteracaoInicial =  year+"-"+month+"-"+day;
          //Data final
          var dateFinal = this.state.dataAlteracaoFinal;
          var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
          var day = this.pad2(dateFinal.getDate());//day (1-31)
          var year= dateFinal.getFullYear();
          dataAlteracaoFinal =  year+"-"+month+"-"+day;
        }

         //Data de Arquivameno
         var dataArquivamentoInicial = '0';
         var dataArquivamentoFinal = '0';
         if(this.state.dataArquivamentoInicial != null && this.state.dataArquivamentoFinal != null) {
           //Data inicial
           var dateInicial = this.state.dataArquivamentoInicial;
           var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
           var day = this.pad2(dateInicial.getDate());//day (1-31)
           var year= dateInicial.getFullYear();
           dataArquivamentoInicial =  year+"-"+month+"-"+day;
           //Data final
           var dateFinal = this.state.dataArquivamentoFinal;
           var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
           var day = this.pad2(dateFinal.getDate());//day (1-31)
           var year= dateFinal.getFullYear();
           dataArquivamentoFinal =  year+"-"+month+"-"+day;
         }

        var campoNumeroProcesso = 'none';
        var campoNumeroCnj = 'none';
        var campoPasta = 'none';
        var campoCliente = 'none';
        var campoParteContraria = 'none';
        var campoAdvogado = 'none';
        var campoTipoDecisao = 'none';
        var campoTipoAcao = 'none';
        var campoAreaAtuacao = 'none';
        var campoDataDecisao = 'none';
        var campoDataCadastro = 'none';
        var campoDataSentenca = 'none';
        var campoDataAlteracao = 'none';
        var campoDataDistribuicao = 'none';
        var campoStatusProcessual = 'none';
        var campoGrupoTrabalho = 'none';
        var campoObjetoAcao = 'none';
        var campoGarantia = 'none';
        var campoValorGarantia = 'none';
        var campoPagamento = 'none';
        var campoValorPagamento = 'none';
        var campoCustas = 'none';
        var campoValorCustas  = 'none';
        var campoPush = 'none';
        var campoPushEmail = 'none';
        var campoPushHistorico = 'none';
        var campoAtividade = 'none';
        var campoDataUltimaAtividade = 'none';
        var campoUltimoHistorico = 'none';
        var campoDataUltimoHistorico = 'none';
        var campoPedidos = 'none';
        var campoValorProvavel = 'none';
        var campoValorPossivel = 'none';
        var campoValorRemoto = 'none';
        var campoValorCausa = 'none';
        var campoRito = 'none';
        var campoMotivoResultado = 'none';
        var campoUf = 'none';
        var campoComarca = 'none';
        var campoDataArquivamento = 'none';
        var campoImportanteEmpresa = 'none';
        var campoImportanteParaMim = 'none';
        var campoEstrategico = 'none';
        var campoResponsavel = 'none';
        var campoObservacao = 'none';
        var campoBanca = 'none';

        for(let i = 0; i < this.state.camposRelatorio.length; i++) {
          if(this.state.camposRelatorio[i] == 'numeroProcesso') {
            campoNumeroProcesso = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'numeroCnj') {
            campoNumeroCnj = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'pasta') {
            campoPasta = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'cliente') {
            campoCliente = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'parteContraria') {
            campoParteContraria = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'advogado') {
            campoAdvogado = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'tipoDecisao') {
            campoTipoDecisao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'tipoAcao') {
            campoTipoAcao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'areaAtuacao') {
            campoAreaAtuacao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataDecisao') {
            campoDataDecisao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataCadastro') {
            campoDataCadastro = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataSentenca') {
            campoDataSentenca = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataAlteracao') {
            campoDataAlteracao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataDistribuicao') {
            campoDataDistribuicao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'statusProcessual') {
            campoStatusProcessual = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'grupoTrabalho') {
            campoGrupoTrabalho = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'objetoAcao') {
            campoObjetoAcao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'garantia') {
            campoGarantia = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorGarantia') {
            campoValorGarantia = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'pagamento') {
            campoPagamento = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorPagamento') {
            campoValorPagamento = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'custas') {
            campoCustas = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorCustas') {
            campoValorCustas = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'push') {
            campoPush = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'pushEmail') {
            campoPushEmail = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'pushHistorico') {
            campoPushHistorico = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'atividade') {
            campoAtividade = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataUltimaAtividade') {
            campoDataUltimaAtividade = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'ultimoHistorico') {
            campoUltimoHistorico = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataUltimoHistorico') {
            campoDataUltimoHistorico = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'pedidos') {
            campoPedidos = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorProvavel') {
            campoValorProvavel = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorPossivel') {
            campoValorPossivel = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorRemoto') {
            campoValorRemoto = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'valorCausa') {
            campoValorCausa = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'rito') {
            campoRito = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'motivoResultado') {
            campoMotivoResultado = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'uf') {
            campoUf = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'comarca') {
            campoComarca = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'dataArquivamento') {
            campoDataArquivamento = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'importanteEmpresa') {
            campoImportanteEmpresa = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'importanteParaMim') {
            campoImportanteParaMim = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'estrategico') {
            campoEstrategico = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'responsavel') {
            campoResponsavel = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'observacao') {
            campoObservacao = 'hide';
          }

          if(this.state.camposRelatorio[i] == 'banca') {
            campoBanca = 'hide';
          }
        }
        
        this.setState({caminhoRelatorio: `#/relatorioProcessoResult/${usuarioLogado.empresa.codigo}/${usuarioLogado.codigo}/${codigosPessoa}/${dataDecisaoInicial}/${dataDecisaoFinal}/${dataSentencaInicial}/${dataSentencaFinal}/${dataDistribuicaoInicial}/${dataDistribuicaoFinal}/${dataCadastroInicial}/${dataCadastroFinal}/${dataAlteracaoInicial}/${dataAlteracaoFinal}/${codigosGrupos}/${codigosObjetos}/${codigosPagamentos}/${operadorLogicoPagamentos}/${this.state.valorPagamento}/${codigosCustas}/${operadorLogicoCustas}/${this.state.valorCustas}/${codigosStatusProcessuais}/${tipoAcao}/${areaAtuacao}/${tipoDecisao}/${this.state.excetoArquivados}/${importanteEmpresa}/${importanteParaMim}/${estrategico}/${codigosPedidos}/${rito}/${motivoResultado}/${dataArquivamentoInicial}/${dataArquivamentoFinal}/${uf}/${responsavel}/${banca}/${campoNumeroProcesso}/${campoNumeroCnj}/${campoPasta}/${campoCliente}/${campoParteContraria}/${campoAdvogado}/${campoTipoDecisao}/${campoTipoAcao}/${campoAreaAtuacao}/${campoDataDecisao}/${campoDataCadastro}/${campoDataSentenca}/${campoDataAlteracao}/${campoDataDistribuicao}/${campoStatusProcessual}/${campoGrupoTrabalho}/${campoObjetoAcao}/${campoGarantia}/${campoValorGarantia}/${campoPagamento}/${campoValorPagamento}/${campoCustas}/${campoValorCustas}/${campoPush}/${campoPushEmail}/${campoPushHistorico}/${campoAtividade}/${campoDataUltimaAtividade}/${campoUltimoHistorico}/${campoDataUltimoHistorico}/${campoPedidos}/${campoValorProvavel}/${campoValorPossivel}/${campoValorRemoto}/${campoValorCausa}/${campoRito}/${campoMotivoResultado}/${campoUf}/${campoComarca}/${campoDataArquivamento}/${campoImportanteEmpresa}/${campoImportanteParaMim}/${campoEstrategico}/${campoResponsavel}/${campoObservacao}/${campoBanca}`});
    }
  }

  limparCamposPesquisa = () => {
    this.setState({selectedPessoa: null});
    this.setState({selectedGrupoTrabalho: null});
    this.setState({selectedStatusProcessual: null});
    this.setState({selectedTipoDecisao: null});
    this.setState({selectedTipoAcao: null});
    this.setState({selectedAreaAtuacao: null});
    this.setState({selectedObjetoAcao: null});
    this.setState({dataDistribuicaoInicial: null});
    this.setState({dataDistribuicaoFinal: null});
    this.setState({dataSentencaInicial: null});
    this.setState({dataSentencaFinal: null});
    this.setState({dataDistribuicaoInicial: null});
    this.setState({dataDistribuicaoFinal: null});
    this.setState({dataDecisaoInicial: null});
    this.setState({dataDecisaoFinal: null});
    this.setState({dataCadastroInicial: null});
    this.setState({dataCadastroFinal: null});
    this.setState({dataAlteracaoInicial: null});
    this.setState({dataAlteracaoFinal: null});
    this.setState({operadorLogicoPagamentos: null});
    this.setState({operadorLogicoCustas: null});
    this.setState({selectedTipoPagamento: null});
    this.setState({selectedTipoCusta: null});
    this.setState({valorPagamento: '0'});
    this.setState({valorCustas: '0'});
    this.setState({selectPedido: null});
    this.setState({selectRito: null});
    this.setState({selectMotivo: null});
    this.setState({selectUf: null});
    this.setState({dataArquivamentoInicial: null});
    this.setState({dataArquivamentoFinal: null});
    this.setState({importanteEmpresa: null});
    this.setState({importanteParaMim: null});
    this.setState({estrategico: null});
    this.setState({responsavel: null});
    this.setState({banca: null});
  }

  exportarRelatorio = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    let listaCampos = [];
    //Código do processo
    listaCampos.push({
      codigo: 0,
      nome: 'Código do Processo'
    })
    for(let i = 0; i < this.state.camposRelatorio.length; i++) {
      if(this.state.camposRelatorio[i] == 'numeroProcesso') {
        listaCampos.push({
          codigo: 1,
          nome: 'Numero Processo'
        });
      }

      if(this.state.camposRelatorio[i] == 'numeroCnj') {
        listaCampos.push({
          codigo: 2,
          nome: 'Numero CNJ'
        });
      }

      if(this.state.camposRelatorio[i] == 'pasta') {
        listaCampos.push({
          codigo: 3,
          nome: 'Pasta'
        });
      }

      if(this.state.camposRelatorio[i] == 'cliente') {
        listaCampos.push({
          codigo: 20,
          nome: 'Autores'
        });
      }

      if(this.state.camposRelatorio[i] == 'parteContraria') {
        listaCampos.push({
          codigo: 21,
          nome: 'Réus'
        })
      }

      if(this.state.camposRelatorio[i] == 'advogado') {
        listaCampos.push({
          codigo: 22,
          nome: 'Outras Partes'
        })
      }

      if(this.state.camposRelatorio[i] == 'tipoDecisao') {
        listaCampos.push({
          codigo: 26,
          nome: 'Tipo Decisao'
        });
      }

      if(this.state.camposRelatorio[i] == 'tipoAcao') {
        listaCampos.push({
          codigo: 25,
          nome: 'Tipo Ação'
        });
      }

      if(this.state.camposRelatorio[i] == 'areaAtuacao') {
        listaCampos.push({
          codigo: 27,
          nome: 'Área de Atuacao'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataDecisao') {
        listaCampos.push({
          codigo: 5,
          nome: 'Data Decisao'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataCadastro') {
        listaCampos.push({
          codigo: 8,
          nome: 'Data Cadastro'
        });
      }

      if(this.state.camposRelatorio[i] == 'comarca') {
        listaCampos.push({
          codigo: 9,
          nome: 'Comarca'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataSentenca') {
        listaCampos.push({
          codigo: 7,
          nome: 'Data Sentenca'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataAlteracao') {
        listaCampos.push({
          codigo: 6,
          nome: 'Data Movimentacao'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataDistribuicao') {
        listaCampos.push({
          codigo: 4,
          nome: 'Data Distribuicao'
        });
      }

      if(this.state.camposRelatorio[i] == 'statusProcessual') {
        listaCampos.push({
          codigo: 24,
          nome: 'Status Processual'
        });
      }

      if(this.state.camposRelatorio[i] == 'grupoTrabalho') {
        listaCampos.push({
          codigo: 23,
          nome: 'Grupo Trabalho'
        });
      }

      if(this.state.camposRelatorio[i] == 'objetoAcao') {
        listaCampos.push({
          codigo: 19,
          nome: 'Objeto Acao'
        });
      }

      if(this.state.camposRelatorio[i] == 'pagamento') {
        listaCampos.push({
          codigo: 28,
          nome: 'Pagamento'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorPagamento') {
        listaCampos.push({
          codigo: 29,
          nome: 'Valor Pagamentos'
        });
      }

      if(this.state.camposRelatorio[i] == 'custas') {
        listaCampos.push({
          codigo: 30,
          nome: 'Custas'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorCustas') {
        listaCampos.push({
          codigo: 31,
          nome: 'Valor Custas'
        });
      }

      if(this.state.camposRelatorio[i] == 'push') {
        listaCampos.push({
          codigo: 11,
          nome: 'Envia Push'
        });
      }

      if(this.state.camposRelatorio[i] == 'pushEmail') {
        listaCampos.push({
          codigo: 12,
          nome: 'Envia Email'
        });
      }

      if(this.state.camposRelatorio[i] == 'pushHistorico') {
        listaCampos.push({
          codigo: 13,
          nome: 'Envia Historico'
        });
      }

      if(this.state.camposRelatorio[i] == 'atividade') {
        listaCampos.push({
          codigo: 15,
          nome: 'Ultima Atividade'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataUltimaAtividade') {
        listaCampos.push({
          codigo: 16,
          nome: 'Dt Ultima Atividade'
        });
      }

      if(this.state.camposRelatorio[i] == 'ultimoHistorico') {
        listaCampos.push({
          codigo: 17,
          nome: 'Ultimo Historico'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataUltimoHistorico') {
        listaCampos.push({
          codigo: 18,
          nome: 'Dt Ultimo Historico'
        });
      }

      if(this.state.camposRelatorio[i] == 'pedidos') {
        listaCampos.push({
          codigo: 10,
          nome: 'Pedidos'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorProvavel') {
        listaCampos.push({
          codigo: 32,
          nome: 'Valor Provável'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorPossivel') {
        listaCampos.push({
          codigo: 33,
          nome: 'Valor Possível'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorRemoto') {
        listaCampos.push({
          codigo: 34,
          nome: 'Valor Remoto'
        });
      }

      if(this.state.camposRelatorio[i] == 'valorCausa') {
        listaCampos.push({
          codigo: 35,
          nome: 'Valor Causa'
        });
      }

      if(this.state.camposRelatorio[i] == 'uf') {
        listaCampos.push({
          codigo: 36,
          nome: 'UF'
        });
      }

      if(this.state.camposRelatorio[i] == 'rito') {
        listaCampos.push({
          codigo: 38,
          nome: 'Rito'
        });
      }

      if(this.state.camposRelatorio[i] == 'motivoResultado') {
        listaCampos.push({
          codigo: 39,
          nome: 'Motivo Resultados'
        });
      }

      if(this.state.camposRelatorio[i] == 'dataArquivamento') {
        listaCampos.push({
          codigo: 40,
          nome: 'Data de Arquivamento'
        })
      }

      if(this.state.camposRelatorio[i] == 'importanteEmpresa') {
        listaCampos.push({
          codigo: 41,
          nome: 'Importante Empresa'
        })
      }

      if(this.state.camposRelatorio[i] == 'importanteParaMim') {
        listaCampos.push({
          codigo: 42,
          nome: 'Importante para Mim'
        })
      }

      if(this.state.camposRelatorio[i] == 'estrategico') {
        listaCampos.push({
          codigo: 43,
          nome: 'Estratégico'
        })
      }

      if(this.state.camposRelatorio[i] == 'responsavel') {
        listaCampos.push({
          codigo: 44,
          nome: 'Responsável'
        })
      }

      if(this.state.camposRelatorio[i] == 'observacao') {
        listaCampos.push({
          codigo: 45,
          nome: 'Observação'
        })
      }

      if(this.state.camposRelatorio[i] == 'banca') {
        listaCampos.push({
          codigo: 46,
          nome: 'Banca'
        })
      }
    }

    var areaAtuacao = 0;
    var tipoDecisao = 0;
    var rito = 0;
    var motivoResultado = 0;
    var uf = '0';
    var importanteEmpresa = '0';
    var importanteParaMim = '0';
    var estrategico = '0';
    var responsavel = '0';
    var banca = '0';

    if(this.state.selectedAreaAtuacao != null) {
      areaAtuacao = this.state.selectedAreaAtuacao.codigo;
    }

    if(this.state.selectedTipoDecisao != null) {
      tipoDecisao = this.state.selectedTipoDecisao.codigo;
    }

    if(this.state.selectRito != null) {
      rito = this.state.selectRito.codigo;
    }

    if(this.state.selectMotivo != null) {
      motivoResultado = this.state.selectMotivo.codigo;
    }

    if(this.state.selectUf != null) {
      uf = this.state.selectUf.codigo;
    }

    if(this.state.importanteEmpresa != null) {
      importanteEmpresa = this.state.importanteEmpresa.codigo;
    }

    if(this.state.importanteParaMim != null) {
      importanteParaMim = this.state.importanteParaMim.codigo;
    }

    if(this.state.estrategico != null) {
      estrategico = this.state.estrategico.codigo;
    }

    if(this.state.responsavel != null) {
      responsavel = this.state.responsavel.codigo;
    }

    if(this.state.banca != null) {
      banca = this.state.banca.codigo;
    }

    var contador = 0;
    var tamanhoLista = 0;

    //Pessoas
    var codigosPessoa = '0';
    if(this.state.selectedPessoa != null) {
      contador = 0;
      tamanhoLista = this.state.selectedPessoa.length;
      for(let i = 0; i < this.state.selectedPessoa.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosPessoa = codigosPessoa + this.state.selectedPessoa[i].codigo + ",";
        } else {
          codigosPessoa = codigosPessoa + this.state.selectedPessoa[i].codigo;
        }
        contador++;
      }
    }

    //Pedidos
    var codigosPedidos = '0'
    if(this.state.selectPedido != null) {
      contador = 0;
      tamanhoLista = this.state.selectPedido.length;
      for(let i = 0; i < this.state.selectPedido.length; i++) {
        if(contador < tamanhoLista - 1) {
          codigosPedidos = codigosPedidos + this.state.selectPedido[i].codigo + ",";
        } else {
          codigosPedidos = codigosPedidos + this.state.selectPedido[i].codigo;
        }
        contador++;
      }
    }

    //Objetos de Ação
    var codigosObjetos = '0';
    if(this.state.selectedObjetoAcao != null) {
      contador = 0;
      tamanhoLista = this.state.selectedObjetoAcao.length;
      for(let i = 0; i < this.state.selectedObjetoAcao.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosObjetos = codigosObjetos + this.state.selectedObjetoAcao[i].codigo + ",";
        } else {
          codigosObjetos = codigosObjetos + this.state.selectedObjetoAcao[i].codigo;
        }

        contador++;
      }
    }

    //Grupos de Trabalho
    var codigosGrupos = '0';
    if(this.state.selectedGrupoTrabalho != null) {
      contador = 0;
      tamanhoLista = this.state.selectedGrupoTrabalho.length;
      for(let i = 0; i < this.state.selectedGrupoTrabalho.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosGrupos = codigosGrupos + this.state.selectedGrupoTrabalho[i].codigo + ",";
        } else {
          codigosGrupos = codigosGrupos + this.state.selectedGrupoTrabalho[i].codigo;
        }

        contador++;
      }
    }

    //Status Processual
    var codigosStatusProcessuais = '0';
    if(this.state.selectedStatusProcessual != null) {
      contador = 0;
      tamanhoLista = this.state.selectedStatusProcessual.length;
      for(let i = 0; i < this.state.selectedStatusProcessual.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosStatusProcessuais = codigosStatusProcessuais + this.state.selectedStatusProcessual[i].codigo + ",";
        } else {
          codigosStatusProcessuais = codigosStatusProcessuais + this.state.selectedStatusProcessual[i].codigo;
        }

        contador++;
      }
    }

    //Pagamentos
    var codigosPagamentos = '0';
    if(this.state.selectedTipoPagamento != null) {
      contador = 0;
      tamanhoLista = this.state.selectedTipoPagamento.length;
      for(let i = 0; i < this.state.selectedTipoPagamento.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosPagamentos = codigosPagamentos + this.state.selectedTipoPagamento[i].codigo + ",";
        } else {
          codigosPagamentos = codigosPagamentos + this.state.selectedTipoPagamento[i].codigo;
        }

        contador++;
      }
    }

    //Valores do pagamento
    var operadorLogicoPagamentos = '0'
    if(this.state.valorPagamento != '0') {
      if(this.state.operadorLogicoPagamentos == null) {
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Informe o operador lógico dos pagamentos', life: 4000});
        return false;
      }

      operadorLogicoPagamentos = this.state.operadorLogicoPagamentos.codigo;
    }

    //Custas
    var codigosCustas = '0';
    if(this.state.selectedTipoCusta != null) {
      contador = 0;
      tamanhoLista = this.state.selectedTipoCusta.length;
      for(let i = 0; i < this.state.selectedTipoCusta.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosCustas = codigosCustas + this.state.selectedTipoCusta[i].codigo + ",";
        } else {
          codigosCustas = codigosCustas + this.state.selectedTipoCusta[i].codigo;
        }
        
        contador++;
      }
    }

    //Valores das custas
    var operadorLogicoCustas = '0';
    if(this.state.valorCustas != '0') {
      if(this.state.operadorLogicoCustas == null) {
        this.toast.show({severity:'error', summary: 'Relatório de Processos', detail:'Informe o operador lógico das custas', life: 4000});
        return false;
      }
      operadorLogicoCustas = this.state.operadorLogicoCustas.codigo;
    }

    //Data de decisão
    var dataDecisaoInicial = '0';
    var dataDecisaoFinal = '0';
    if(this.state.dataDecisaoInicial != null && this.state.dataDecisaoFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataDecisaoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataDecisaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataDecisaoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataDecisaoFinal =  year+"-"+month+"-"+day;
    }

    //Data da sentença
    var dataSentencaInicial = '0';
    var dataSentencaFinal = '0';
    if(this.state.dataSentencaInicial != null && this.state.dataSentencaFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataSentencaInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataSentencaInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataSentencaFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataSentencaFinal =  year+"-"+month+"-"+day;
    }

    //Data da distribuição
    var dataDistribuicaoInicial = '0';
    var dataDistribuicaoFinal = '0';
    if(this.state.dataDistribuicaoInicial != null && this.state.dataDistribuicaoFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataDistribuicaoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataDistribuicaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataDistribuicaoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataDistribuicaoFinal =  year+"-"+month+"-"+day;
    }

    //Data de Cadastro
    var dataCadastroInicial = '0';
    var dataCadastroFinal = '0';
    if(this.state.dataCadastroInicial != null && this.state.dataCadastroFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataCadastroInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataCadastroInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataCadastroFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataCadastroFinal =  year+"-"+month+"-"+day;
    }

    //Data de Alteração
    var dataAlteracaoInicial = '0';
    var dataAlteracaoFinal = '0';
    if(this.state.dataAlteracaoInicial != null && this.state.dataAlteracaoFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataAlteracaoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataAlteracaoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataAlteracaoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataAlteracaoFinal =  year+"-"+month+"-"+day;
    }

    //Data de Arquivamento
    var dataArquivamentoInicial = '0';
    var dataArquivamentoFinal = '0';
    if(this.state.dataArquivamentoInicial != null && this.state.dataArquivamentoFinal != null) {
      //Data inicial
      var dateInicial = this.state.dataArquivamentoInicial;
      var month = this.pad2(dateInicial.getMonth()+1);//months (0-11)
      var day = this.pad2(dateInicial.getDate());//day (1-31)
      var year= dateInicial.getFullYear();
      dataArquivamentoInicial =  year+"-"+month+"-"+day;
      //Data final
      var dateFinal = this.state.dataArquivamentoFinal;
      var month = this.pad2(dateFinal.getMonth()+1);//months (0-11)
      var day = this.pad2(dateFinal.getDate());//day (1-31)
      var year= dateFinal.getFullYear();
      dataArquivamentoFinal =  year+"-"+month+"-"+day;
    }

    if(this.state.importancia == null) {
      this.setState({importancia: 'N'});
    }
    
    const filtro = {
      pessoa: codigosPessoa,
      grupoTrabalho: codigosGrupos,
      areaAtucacao: areaAtuacao,
      tipoDecisao: tipoDecisao,
      dataInicialDecisao: dataDecisaoInicial,
      dataFinalDecisao: dataDecisaoFinal,
      dataInicialDistribuicao: dataDistribuicaoInicial,
      dataFinalDistribuicao: dataDistribuicaoFinal,
      statusProcessual: codigosStatusProcessuais,
      excetoProcessosArquivados: '',
      dataInicialSentenca: dataSentencaInicial,
      dataFinalSentenca: dataSentencaFinal,
      objetoAcao: codigosObjetos,
      garantia: '',
      operadorLogicoGarantia: '',
      valorGarantia: '',
      pagamentos: codigosPagamentos,
      operadorLogicoPagamento: operadorLogicoPagamentos,
      valorPagamento: this.state.valorPagamento,
      custas: codigosCustas,
      operadorLogicoCustas: operadorLogicoCustas,
      valorCustas: this.state.valorCustas,
      dataInicialCadastro: dataCadastroInicial,
      dataFinalCadastro: dataCadastroFinal,
      dataInicialAlteracao: dataAlteracaoInicial,
      dataFinalAlteracao: dataAlteracaoFinal,
      importanteEmpresa: importanteEmpresa,
      importanteParaMim: importanteParaMim,
      estrategico: estrategico,
      responsavel: responsavel,
      pedidos: codigosPedidos,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo,
      rito: rito,
      motivoResultado: motivoResultado,
      uf: uf,
      dataArquivamentoInicial: dataArquivamentoInicial,
      dataArquivamentoFinal: dataArquivamentoFinal,
      banca: banca
    };

    const relatorioProcesso = {
      usuario: usuarioLogado,
      campos: listaCampos,
      filtro: filtro
    };

    this.setState({openSpinner: true});
    await this.relatorioProcessoService.exportarRelatorio(relatorioProcesso)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Relatório de Processo', detail:'Processo gerado com sucesso', life: 4000});
        this.download(response.data);
        this.consultaRelatoriosUsuario();
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text" 
                tooltip="Download"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Relatório"
                onClick={() => this.confirmaExclusaoRelatorio(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  consultarRelatorio = (relatorio) => {
    this.relatorioProcessoService.consultarRelatorio(relatorio.codigo)
      .then(response => {
        this.setState({relatorioArquivo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:'Erro ao consultar relatório', life: 4000});
      })
  }

  async download(relatorio){
    await this.consultarRelatorio(relatorio);
    await this.relatorioProcessoService.download(relatorio.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.relatorioArquivo.relatorio); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:'Erro executar download de relatório', life: 4000});
      })
  }

  accepExcluirRelatorio() {
    this.excluirRelatorio();
  }

  confirmaExclusaoRelatorio(relatorio) {
      this.setState({codigoExcluirRelatorio: relatorio.codigo});
      confirmDialog({
          message: 'Deseja realmente excluir este relatório ?',
          header: 'Exclusão de Relatório',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: this.accepExcluirRelatorio,
          reject: this.reject
      });
  }

  excluirRelatorio = () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.relatorioProcessoService.excluirRelatorio(this.state.codigoExcluirRelatorio, usuarioLogado.codigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Relatório de Processo', detail:'Relatório excluído', life: 4000});
        this.consultaRelatoriosUsuario();
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Relatório de Processo', detail:`${this.state.detail}`, life: 4000});
      })
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={this.state.openSpinner}>
            <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
          </Backdrop>
          <div className="content-wrapper">
            <section className="content-header">
              <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="pi pi-file-pdf"></i>
                          <span> Relatório de Processos</span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label>Pessoa(s) (Autores, Parte Contrária, Advogados outra parte)</label>
                              <AutoComplete value={this.state.selectedPessoa}
                                            suggestions={this.state.filterPessoas} 
                                            completeMethod={this.consultarPessoa}
                                            style={{width: '100%'}} 
                                            field="nome" multiple onChange={(e) => this.setState({selectedPessoa: e.value })} 
                                            className="p-autoComplete-sm p-d-block p-mb-0"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Grupo de Trbalho</label>
                              <MultiSelect inputId="multiselect" 
                                           value={this.state.selectedGrupoTrabalho} 
                                           options={this.state.gruposTrabalho} 
                                           style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                           onChange={(e) => this.setState({ selectedGrupoTrabalho: e.value })} 
                                           filter showClear filterBy="nome"
                                           optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Status Processual</label>
                              <MultiSelect inputId="statusProcessualId" 
                                           value={this.state.selectedStatusProcessual} 
                                           options={this.state.statusProcessual} 
                                           style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                           onChange={(e) => this.setState({ selectedStatusProcessual: e.value })} 
                                           filter showClear 
                                           filterBy="descricao"
                                           optionLabel="descricao" />

                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Tipo de Ação</label>
                              <Dropdown   inputId="tipoAcaoId" 
                                          value={this.state.selectedTipoAcao} 
                                          options={this.state.tiposAcao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ selectedTipoAcao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Tipo de Decisão</label>
                              <Dropdown   inputId="tipoDecisaoId" 
                                          value={this.state.selectedTipoDecisao} 
                                          options={this.state.tiposDecisao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ selectedTipoDecisao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Área de Atuação</label>
                              <Dropdown   inputId="areaAtuacaoId" 
                                          value={this.state.selectedAreaAtuacao} 
                                          options={this.state.areasAtuacao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ selectedAreaAtuacao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Objetos de Ação</label>
                              <MultiSelect inputId="multiselect" 
                                          value={this.state.selectedObjetoAcao} 
                                          options={this.state.objetosAcao} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ selectedObjetoAcao: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Distribuição</label>
                              <Calendar id="mask" 
                                        value={this.state.dataDistribuicaoInicial} 
                                        onChange={(e) => this.setState({ dataDistribuicaoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataDistribuicaoFinal} 
                                          onChange={(e) => this.setState({ dataDistribuicaoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data da última decisão</label>
                              <Calendar id="mask" 
                                        value={this.state.dataDecisaoInicial} 
                                        onChange={(e) => this.setState({ dataDecisaoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataDecisaoFinal} 
                                          onChange={(e) => this.setState({ dataDecisaoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data da última alteração</label>
                              <Calendar id="mask" 
                                        value={this.state.dataAlteracaoInicial} 
                                        onChange={(e) => this.setState({ dataAlteracaoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataAlteracaoFinal} 
                                          onChange={(e) => this.setState({ dataAlteracaoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Cadastro</label>
                              <Calendar id="mask" 
                                        value={this.state.dataCadastroInicial} 
                                        onChange={(e) => this.setState({ dataCadastroInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataCadastroFinal} 
                                          onChange={(e) => this.setState({ dataCadastroFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Data de Arquivamento</label>
                              <Calendar id="mask" 
                                        value={this.state.dataArquivamentoInicial} 
                                        onChange={(e) => this.setState({ dataArquivamentoInicial: e.value })} 
                                        style={{width: '100%', height: '32px'}} 
                                        dateFormat="dd/mm/yy"
                                        mask="99/99/9999"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              &nbsp;
                              <Calendar id="mask" 
                                          value={this.state.dataArquivamentoFinal} 
                                          onChange={(e) => this.setState({ dataArquivamentoFinal: e.value })} 
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"/>
                            </div>
                          </div>
                        </div>
                         <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Rito</label>
                              <Dropdown inputId="rito" 
                                        value={this.state.selectRito} 
                                        options={this.state.ritos} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ selectRito: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Motivo Resultado</label>
                              <Dropdown inputId="motivo" 
                                        value={this.state.selectMotivo} 
                                        options={this.state.motivos} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ selectMotivo: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>UF</label>
                              <Dropdown inputId="uf" 
                                        value={this.state.selectUf} 
                                        options={this.estados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ selectUf: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Pagamentos</label>
                              <MultiSelect inputId="pagamentoId" 
                                           value={this.state.selectedTipoPagamento} 
                                           options={this.state.tiposPagamento} 
                                           style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                           onChange={(e) => this.setState({ selectedTipoPagamento: e.value })} 
                                           filter showClear filterBy="nome"
                                           optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Operador Lógico Pagamentos</label>
                              <Dropdown inputId="opLogicoPagamentoId" 
                                        value={this.state.operadorLogicoPagamentos} 
                                        options={this.operadorLogicoOptions} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ operadorLogicoPagamentos: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Valor Pagamentos</label>
                              <InputNumber inputId="valorPagamentoId" 
                                           value={this.state.valorPagamento} 
                                           style={{width: '100%', height: '32px'}} 
                                           onChange={(e) => this.setState({valorPagamento: e.value})} 
                                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Custas</label>
                              <MultiSelect inputId="pagamentoId" 
                                           value={this.state.selectedTipoCusta} 
                                           options={this.state.tiposCusta} 
                                           style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                           onChange={(e) => this.setState({ selectedTipoCusta: e.value })} 
                                           filter showClear filterBy="nome"
                                           optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Operador Lógico Custas</label>
                              <Dropdown inputId="opLogicoCustasId" 
                                        value={this.state.operadorLogicoCustas} 
                                        options={this.operadorLogicoOptions} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ operadorLogicoCustas: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Valor Custas</label>
                              <InputNumber inputId="valorCustaId" 
                                           value={this.state.valorCustas} 
                                           style={{width: '100%', height: '32px'}} 
                                           onChange={(e) => this.setState({valorCustas: e.value})} 
                                           mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                              <label>Pedidos</label>
                              <MultiSelect inputId="pedidos" 
                                          value={this.state.selectPedido} 
                                          options={this.state.pedidos} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ selectPedido: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Responsável</label>
                              <Dropdown inputId="responsavel" 
                                          value={this.state.responsavel} 
                                          options={this.state.usuarios} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ responsavel: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                              <label>Bancada</label>
                              <Dropdown inputId="bancada" 
                                          value={this.state.banca} 
                                          options={this.state.bancada} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ banca: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Importante Empresa</label>
                              <Dropdown   inputId="importanteEmpresa" 
                                          value={this.state.importanteEmpresa} 
                                          options={this.importanteEmpresa} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ importanteEmpresa: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-group">
                              <label>Estratégico</label>
                              <Dropdown   inputId="estrategico" 
                                          value={this.state.estrategico} 
                                          options={this.estrategico} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ estrategico: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                          <div className="col-sm-2">
                            <div className="form-group">
                              <label>Importante para mim</label>
                              <Dropdown   inputId="importanteParaMim" 
                                          value={this.state.importanteParaMim} 
                                          options={this.importanteParaMim} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ importanteParaMim: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" />
                            </div>
                          </div>
                        </div>
                        <hr></hr>
                        <span style={{padding: '12px', fontSize: '16px', fontStyle: 'italic', fontWeight: 'bold'}}>
                           Campos para Exibição
                        </span>
                        <br></br>
                        <br></br>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="camposRelatorio">
                                <Checkbox inputId="numeroProcesso" 
                                          name="numeroProcesso" 
                                          value="numeroProcesso" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('numeroProcesso') !== -1} />
                                &nbsp;
                                Número do Processo
                                &nbsp;
                                <Checkbox inputId="numeroCNJ" 
                                          name="numeroCnj" 
                                          value="numeroCnj" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('numeroCnj') !== -1} />
                                &nbsp;
                                Número do CNJ
                                &nbsp;
                                <Checkbox inputId="pasta" 
                                          name="pasta" 
                                          value="pasta" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('pasta') !== -1} />
                                &nbsp;
                                Número da Pasta
                                &nbsp;
                                <Checkbox inputId="cliente" 
                                          name="cliente" 
                                          value="cliente" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('cliente') !== -1} />
                                &nbsp;
                                Autor(es)
                                &nbsp;
                                <Checkbox inputId="parteContraria" 
                                          name="parteContraria" 
                                          value="parteContraria" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('parteContraria') !== -1} />
                                &nbsp;
                                Réu(s)
                                &nbsp;
                                <Checkbox inputId="advogado" 
                                          name="advogado" 
                                          value="advogado" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('advogado') !== -1} />
                                &nbsp;
                                Outras partes
                                &nbsp;
                                <Checkbox inputId="banca" 
                                          name="banca" 
                                          value="banca" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('banca') !== -1} />
                                &nbsp;
                                Bancada de Advogados
                                &nbsp;
                                <Checkbox inputId="areaAtuacao" 
                                          name="areaAtuacao" 
                                          value="areaAtuacao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('areaAtuacao') !== -1} />
                                &nbsp;
                                Área de Atuação
                                &nbsp;
                                <Checkbox inputId="tipoDecisao" 
                                          name="tipoDecisao" 
                                          value="tipoDecisao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('tipoDecisao') !== -1} />
                                &nbsp;
                                Tipo de Decisao
                                &nbsp;
                                <Checkbox inputId="dataDecisao" 
                                          name="dataDecisao" 
                                          value="dataDecisao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataDecisao') !== -1} />
                                &nbsp;
                                Data última decisão
                                &nbsp;
                                <Checkbox inputId="dataDistribuicao" 
                                          name="dataDistribuicao" 
                                          value="dataDistribuicao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataDistribuicao') !== -1} />
                                &nbsp;
                                Data de Distribuição
                                &nbsp;
                                <Checkbox inputId="statusProcessual" 
                                          name="statusProcessual" 
                                          value="statusProcessual" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('statusProcessual') !== -1} />
                                &nbsp;
                                Status Processual
                              </label>
                            </div>
                          </div>
                          
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="camposRelatorio">
                                <Checkbox inputId="tipoAcao" 
                                          name="tipoAcao" 
                                          value="tipoAcao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('tipoAcao') !== -1} />
                                &nbsp;
                                Tipo de Ação
                                &nbsp;
                                <Checkbox inputId="grupoTrabalho" 
                                          name="grupoTrabalho" 
                                          value="grupoTrabalho" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('grupoTrabalho') !== -1} />
                                &nbsp;
                                Grupo de Trabalho
                                &nbsp;
                                <Checkbox inputId="objetoAcao" 
                                          name="objetoAcao" 
                                          value="objetoAcao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('objetoAcao') !== -1} />
                                &nbsp;
                                Objeto de Ação
                                &nbsp;
                                <Checkbox inputId="garantia" 
                                          name="garantia" 
                                          value="garantia" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('garantia') !== -1} />
                                &nbsp;
                                Garantias
                                &nbsp;
                                <Checkbox inputId="valorGarantia" 
                                          name="valorGarantia" 
                                          value="valorGarantia" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorGarantia') !== -1} />
                                &nbsp;
                                Valor Garantias
                                &nbsp;
                                <Checkbox inputId="pagamento" 
                                          name="pagamento" 
                                          value="pagamento" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('pagamento') !== -1} />
                                &nbsp;
                                Pagamentos
                                &nbsp;
                                <Checkbox inputId="valorPagamento" 
                                          name="valorPagamento" 
                                          value="valorPagamento" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorPagamento') !== -1} />
                                &nbsp;
                                Valor Pagamentos
                                &nbsp;
                                <Checkbox inputId="custas" 
                                          name="custas" 
                                          value="custas" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('custas') !== -1} />
                                &nbsp;
                                Custas
                                &nbsp;
                                <Checkbox inputId="valorCustas" 
                                          name="valorCustas" 
                                          value="valorCustas" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorCustas') !== -1} />
                                &nbsp;
                                Valor Custas
                                &nbsp;
                                <Checkbox inputId="comarca" 
                                          name="comarca" 
                                          value="comarca" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('comarca') !== -1} />
                                &nbsp;
                                Comarca
                                &nbsp;
                                <Checkbox inputId="dataArquivamento" 
                                          name="dataArquivamento" 
                                          value="dataArquivamento" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataArquivamento') !== -1} />
                                &nbsp;
                                Data Arquivamento
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="camposRelatorio">
                                <Checkbox inputId="dataAlteracao" 
                                          name="dataAlteracao" 
                                          value="dataAlteracao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataAlteracao') !== -1} />
                                &nbsp;
                                Data última alteração
                                &nbsp;
                                <Checkbox inputId="dataCadastro" 
                                          name="dataCadastro" 
                                          value="dataCadastro" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataCadastro') !== -1} />
                                &nbsp;
                                Data Cadastro
                                &nbsp;
                                <Checkbox inputId="dataSentenca" 
                                          name="dataSentenca" 
                                          value="dataSentenca" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataSentenca') !== -1} />
                                &nbsp;
                                Data Sentença
                                &nbsp;
                                <Checkbox inputId="push" 
                                          name="push" 
                                          value="push" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('push') !== -1} />
                                Processo no Push
                                &nbsp;
                                <Checkbox inputId="pushEmail" 
                                          name="pushEmail" 
                                          value="pushEmail" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('pushEmail') !== -1} />
                                &nbsp;
                                Envio por Email
                                &nbsp;
                                <Checkbox inputId="pushHistorico" 
                                          name="pushHistorico" 
                                          value="pushHistorico" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('pushHistorico') !== -1} />
                                &nbsp;
                                Registro no Histórico
                                &nbsp;
                                <Checkbox inputId="atividade" 
                                          name="atividade" 
                                          value="atividade" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('atividade') !== -1} />
                                &nbsp;
                                Última Atividade
                                &nbsp;
                                <Checkbox inputId="dataUltimaAtividade" 
                                          name="dataUltimaAtividade" 
                                          value="dataUltimaAtividade" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataUltimaAtividade') !== -1} />
                                &nbsp;
                                Dt. Última Atividade
                                &nbsp;
                                <Checkbox inputId="ultimoHistorico" 
                                          name="ultimoHistorico" 
                                          value="ultimoHistorico" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('ultimoHistorico') !== -1} />
                                &nbsp;
                                Último Histórico
                                &nbsp;
                                <Checkbox inputId="dataUltimoHistorico" 
                                          name="dataUltimoHistorico" 
                                          value="dataUltimoHistorico" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('dataUltimoHistorico') !== -1} />
                                &nbsp;
                                Dt. Último Histórico
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="camposRelatorio">
                                <Checkbox inputId="rito"
                                          name="rito" 
                                          value="rito" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('rito') !== -1} />
                                &nbsp;
                                Rito
                                &nbsp;
                                <Checkbox inputId="motivoResultado" 
                                          name="motivoResultado" 
                                          value="motivoResultado" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('motivoResultado') !== -1} />
                                &nbsp;
                                Motivo Resultado
                                &nbsp;
                                <Checkbox inputId="uf" 
                                          name="uf" 
                                          value="uf" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('uf') !== -1} />
                                &nbsp;
                                UF
                                &nbsp;
                                <Checkbox inputId="pedidos" 
                                          name="pedidos" 
                                          value="pedidos" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('pedidos') !== -1} />
                                &nbsp;
                                Pedidos
                                &nbsp;
                                <Checkbox inputId="valorProvavel" 
                                          name="valorProvavel" 
                                          value="valorProvavel" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorProvavel') !== -1} />
                                &nbsp;
                                Valor Provável
                                &nbsp;
                                <Checkbox inputId="valorPossivel" 
                                          name="valorPossivel" 
                                          value="valorPossivel" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorPossivel') !== -1} />
                                &nbsp;
                                Valor Possível
                                &nbsp;
                                <Checkbox inputId="valorRemoto" 
                                          name="valorRemoto" 
                                          value="valorRemoto" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorRemoto') !== -1} />
                                &nbsp;
                                Valor Remoto
                                &nbsp;
                                <Checkbox inputId="valorCausa" 
                                          name="valorCausa" 
                                          value="valorCausa" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('valorCausa') !== -1} />
                                &nbsp;
                                Valor Causa
                                &nbsp;
                                <Checkbox inputId="importanteEmpresa" 
                                          name="importanteEmpresa" 
                                          value="importanteEmpresa" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('importanteEmpresa') !== -1} />
                                &nbsp;
                                Importante Empresa
                                &nbsp;
                                <Checkbox inputId="estrategico" 
                                          name="estrategico" 
                                          value="estrategico" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('estrategico') !== -1} />
                                &nbsp;
                                Estratégico
                                &nbsp;
                                <Checkbox inputId="importanteParaMim" 
                                          name="importanteParaMim" 
                                          value="importanteParaMim" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('importanteParaMim') !== -1} />
                                &nbsp;
                                Importante para Mim
                                &nbsp;
                                <Checkbox inputId="responsavel" 
                                          name="responsavel" 
                                          value="responsavel" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('responsavel') !== -1} />
                                &nbsp;
                                Responsável
                                &nbsp;
                                <Checkbox inputId="observacao" 
                                          name="observacao" 
                                          value="observacao" 
                                          onChange={this.onCamposChange} 
                                          checked={this.state.camposRelatorio.indexOf('observacao') !== -1} />
                                &nbsp;
                                Observação
                              </label>
                            </div>
                          </div>
                        </div>
                        <hr></hr>
                        <br></br>
                        <div>
                        <Accordion>
                          <AccordionTab header="Outros Relatórios">
                            <Button label="Contingência" className="p-button-raised" />
                            &nbsp;&nbsp;&nbsp;
                            <Button label="Pagamentos" className="p-button-raised" />
                            &nbsp;&nbsp;&nbsp;
                            <Button label="Garantias" className="p-button-raised" />
                          </AccordionTab>
                        </Accordion>
                        </div>
                        <hr></hr>
                        <br></br>
                        <div style={{paddingLeft: '12px'}}>
                            <a href={this.state.caminhoRelatorio} target="_blank" onClick={this.emitirRelatorio}>
                              <Button label="Emitir Relatório"
                                      className="p-button-primary p-button-text"/>
                            </a>
                            &nbsp;
                            <Button label="Exportar Relatório"
                                      className="p-button-primary p-button-text"
                                      onClick={this.exportarRelatorio}/>
                            &nbsp;
                            <Button label="Limpar Campos" 
                                    className="p-button-secondary p-button-text"
                                    onClick={this.limparCamposPesquisa}/>
                        
                        </div>
                      </div>
                      <hr></hr>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-12">
                          <DataTable value={this.state.relatoriosExportados}  paginator responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage="Nehum relatório gerado"
                            selectionMode="multiple">
                            <Column field="relatorio" header="Relatório"></Column>
                            <Column field="dataRelatorio" header="Data Geração"></Column>
                            <Column body={this.acoes} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                          </DataTable>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
      </>
    )
  }
}

RelatorioProcessos.contextType = AuthContext;
export default withRouter(RelatorioProcessos)
